import { render, staticRenderFns } from "./trackRouteHeader.vue?vue&type=template&id=5d3d20fe&scoped=true"
import script from "./trackRouteHeader.vue?vue&type=script&lang=js"
export * from "./trackRouteHeader.vue?vue&type=script&lang=js"
import style0 from "./trackRouteHeader.vue?vue&type=style&index=0&id=5d3d20fe&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3d20fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d3d20fe')) {
      api.createRecord('5d3d20fe', component.options)
    } else {
      api.reload('5d3d20fe', component.options)
    }
    module.hot.accept("./trackRouteHeader.vue?vue&type=template&id=5d3d20fe&scoped=true", function () {
      api.rerender('5d3d20fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderCenter/logisticsOrders/components/trackQuery/trackRouteHeader.vue"
export default component.exports